import widgetsSlice from './slice';
import * as selectors from './selectors';
import * as actions from './actions';

export const WidgetsActions = { ...actions, ...widgetsSlice.actions };
export const WidgetsReducer = widgetsSlice.reducer;
export const WidgetsSelectors = selectors;
